module.exports = __webpack_public_path__ + "img/shade_quote_logo.7f576331.svg";